import Vue from 'vue'
import App from './App.vue'
import 'foundation-sites/dist/css/foundation.min.css'
import 'foundation-sites/dist/css/foundation-prototype.min.css'
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css'
import axios from "axios"
import router from './router'
import { store } from './store'
import VueSimpleAlert from "vue-simple-alert"
import VTooltip from 'v-tooltip'

Vue.use(VTooltip)
 
Vue.use(VueSimpleAlert)

Vue.prototype.$http = axios
Vue.prototype.$axios = axios
Vue.prototype.$store = store

Vue.config.productionTip = false

Vue.prototype.$sleep = function(milliseconds) {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
